module.exports = __webpack_public_path__ + "img/ppt.077fc32e.svg";